import React from 'react';
import renderHTML from 'react-render-html';
import { IMAGE_BASE_LINK } from '../../../../app-constants';
import { stripStartingAndEndingPTags } from '../../../ssm-homepage/ssm-homepage.actions';
import './benefit.css';

const Benefit = (props) => {
  const {
    benefit: {
      title,
      imagePath,
      summary,
      benefitValues,
    },
    customSubHeadingClass,
    customDescriptionClass,
    applyOffset,
  } = props;
  return (
    <div className={`${applyOffset ? 'benefit-section offset-lg-2 col-lg-4 col-sm-12' : 'benefit-section col-lg-4  col-sm-12'}`}>
      <img className="benefit-img" alt={imagePath} src={`${IMAGE_BASE_LINK}/${imagePath}`} />
      <div className="summary-detail col pl-sm-0 pl-0">
        {benefitValues && (<div className="benefit-value">{renderHTML(benefitValues)}</div>)}
        <h2 id="summary-heading" className={customSubHeadingClass ? `${customSubHeadingClass}` : 'summary-heading'}>{title}</h2>
        {summary && (<div
          id="summary-description"
          className={customDescriptionClass ? `${customDescriptionClass}` : 'summary-description'}
        >{renderHTML(stripStartingAndEndingPTags(summary))}</div>)}
      </div>
    </div>
  );
};

export default Benefit;
